import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Review from './Review';
import ReviewsCarousel from './ReviewsCarousel';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ReviewsTab(props) {
  const [valueTab, setValueTab] = React.useState(0);
  const { isSmallScreen, setValue } = props;
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const ref = React.useRef(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setValue(3);
        }
      },
      { threshold: 0.9 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div ref={ref} style={{ margin: isSmallScreen ? "4rem 0 0 0px" : "60px" }} id="reviews">
      <div style={{ margin: isSmallScreen ? "0 0 0 20px" : "0" }} >
        <div className={isSmallScreen ? 'only-heading-sm' : 'only-heading'}>Reviews</div>
      </div>
      <Box sx={{ width: '100%', marginTop: isSmallScreen && "1rem" }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={valueTab} onChange={handleChange} aria-label="basic tabs example">
            <Tab style={{
              color: "black",
              fontFamily: "Open Sans",
              textTransform: "none",
              fontSize: "1.1rem",
              fontWeight: "600",
              paddingTop: "2%"
            }} label="LinkedIn Reviews" {...a11yProps(0)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <ReviewsCarousel isSmallScreen={isSmallScreen} />
        </CustomTabPanel>
      </Box>
    </div>
  );
}
